/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SearchResponse } from '../../models/search-response';

export interface SearchByTag$Params {
  search: string;
  offset: number;
  limit: number;
}

export function searchByTag(http: HttpClient, rootUrl: string, params: SearchByTag$Params, context?: HttpContext): Observable<StrictHttpResponse<SearchResponse>> {
  const rb = new RequestBuilder(rootUrl, searchByTag.PATH, 'get');
  if (params) {
    rb.path('search', params.search, {});
    rb.path('offset', params.offset, {});
    rb.path('limit', params.limit, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SearchResponse>;
    })
  );
}

searchByTag.PATH = '/rest/search-by-tag/{search}/{offset}/{limit}';
